export const statusOptions = {
  All: 0,
  Live: 1,
  Staging: 3,
  Sold: 5,
  Rejected: 9,
  "On Deposit": 10,
  "In Transit": 7,
  "In Transit Sold": 12,
  "In Transit At Port": 11,
  "In Transit At Factory": 13
  // "Pending Approval": 14
} as const;

export type statusOptionsValues =
  (typeof statusOptions)[keyof typeof statusOptions];
export type statusOptionsLabels = keyof typeof statusOptions;
export const statusOptionsLabelsList = Object.keys(
  statusOptions
) as statusOptionsLabels[];

export const statusOptionsValuesList = Object.values(
  statusOptions
) as statusOptionsValues[];

export const statusOptionsGetValue = (
  value: statusOptionsLabels
): statusOptionsValues => {
  return statusOptions[value];
};

export const statusOptionsGetLabel = (
  value: statusOptionsValues
): statusOptionsLabels => {
  return statusOptionsLabelsList[statusOptionsValuesList.indexOf(value)];
};
